import React, { Component } from "react"
import { Tag } from "antd";
import classnames from "classnames";
import styles from './tagControl.module.less'
import hexRgb from "hex-rgb";

export default class TagControl extends Tag {
    render() {
        const { className, color, children, style, ...parameter } = this.props;
        let showColor = color;
        let rgb = ``;
        try {
            rgb = hexRgb(showColor);
        } catch (error) {
            rgb = undefined;
        }
        if (!rgb) {
            showColor = (color && color.length > 0 && styles[color.toUpperCase()]) ? styles[color.toUpperCase()] : `#bfbfbf`;
            rgb = hexRgb(showColor);
        }
        return (
            <span
                className={classnames(className, styles.tag)}
                style={{
                    ...style,
                    background: `rgba(${rgb.red},${rgb.green},${rgb.blue},0.4)`,
                    border: `1px solid ${showColor}`,
                }}
                {...parameter}>
                {children}
            </span>
        )
    }
}